module.exports = __webpack_public_path__ + "static/DavidBowie-f4fa24491c920848b656f86d2f06ea41.jpg";